"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classNames = require("../customPropTypes/classNames");
var _spacing = require("../customPropTypes/spacing");
var _SvgIcon = _interopRequireDefault(require("../SvgIcon"));
var _jsxRuntime = require("react/jsx-runtime");
var _path;
function IconPenta(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SvgIcon["default"], (0, _extends2["default"])({
    viewBox: "0 0 24 28"
  }, props, {
    children: _path || (_path = /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M0 27.878c0-.068.229-.259.5-.422.773-.448 1.746-1.563 2.104-2.42l.329-.774V14.136c0-9.542-.014-10.167-.272-10.874C2.318 2.283 1.474 1.223.658.734-.544.014-.458 0 4.864 0h4.864v11.866c0 13.076-.028 12.64.902 14.082.272.42.772.965 1.116 1.196.343.244.758.53.915.639.258.176-.457.203-6.18.217C2.632 28 0 27.946 0 27.878Zm12.018-12.75c0-.068.3-.204.672-.299 1.602-.394 2.804-1.74 3.462-3.86.3-.965.33-1.264.272-3.126-.072-2.175-.286-3.031-1.116-4.58-.658-1.238-1.803-2.393-2.747-2.8C11.56.04 11.903-.042 14.35.04c1.96.054 2.489.122 3.462.421 2.675.816 4.592 2.488 5.365 4.703.457 1.278.457 3.765 0 5.03-.844 2.323-2.819 3.86-5.938 4.634-1.23.313-5.222.544-5.222.3Z"
    }))
  }));
}
process.env.NODE_ENV !== "production" ? IconPenta.propTypes = {
  /** size of icon */
  size: _propTypes["default"].oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: _classNames.classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: _propTypes["default"].oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: _spacing.marginPropTypes
} : void 0;
IconPenta.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};
var _default = IconPenta;
exports["default"] = _default;